import { mapMutations, mapGetters } from "vuex";

const registerAgentPopup = () => import("@/components/popups/register-agent/index.vue");
const registerAgentPopupThanks = () => import("@/components/popups/register-agent-thanks/index.vue");
const registerPopup = () => import("@/components/popups/register/index.vue");
const restorePasswordMain = () => import("@/components/popups/restore-password-main/index.vue");
const personalData = () => import("@/components/popups/personal-data/index.vue");
const fastBuy = () => import("@/components/popups/fast-buy/index.vue");
const setNewPassword = () => import("@/components/popups/set-new-password/index.vue");
const confirmPayment = () => import("@/components/popups/confirm-payment/index.vue");
const changeMainAddress = () => import("@/components/popups/change-main-address/index.vue");
const warning = () => import("@/components/popups/warning/index.vue");
const notLeave = () => import("@/components/popups/not-leave-page/index.vue");
const needConsultation = () => import("@/components/popups/need-consultation/index.vue");

//
export default {
    name: "hidden",
    data() {
        return {
            startDate: Date.now(),
        }
    },
    components: {
        registerAgentPopupThanks,
        registerAgentPopup,
        registerPopup,
        restorePasswordMain,
        personalData,
        fastBuy,
        setNewPassword,
        confirmPayment,
        changeMainAddress,
        warning,
        notLeave,
        needConsultation,
    },
    computed: {
        ...mapGetters({
            popupRegister: "auth/popupRegister",
            popupRegisterAgent: "auth/popupRegisterAgent",
            popupRegisterAgentThanks: "auth/popupRegisterAgentThanks",
            showRestorePassword: "auth/showRestorePassword",
            showPersonalData: "auth/showPersonalData",
            popupFastBuy: "card/popupFastBuy",
            popupConfirmPayment: "payment/showPopupConfirmPayment",
            popupSetNewPassword: "auth/showSetNewPassword",
            popupChangeAddress: "profile/openPopUpAddressChange",
            warningStatus: "setting/warningStatus",
            showNotLeavePopup: "setting/showNotLeavePopup",
            showNeedConsultation: "setting/showNeedConsultation",
        }),
        // canShowNotLeavePopup() {
        //     let currentTime = Date.now();
        //     let timeSpentOnSite = currentTime - startTime;
        //     let timeSpentInMinutes = timeSpentOnSite / (1000 * 60);
        //     return timeSpentInMinutes > 3;
        // },
    },
    methods: {
        ...mapMutations({
            changePopupWarning: `setting/SET_WARNING_STATUS`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
            changePopupRegisterAgent: `auth/CHANGE_POPUP_REGISTER_AGENT`,
            changePopupRegisterAgentThanks: `auth/CHANGE_POPUP_REGISTER_AGENT_THANKS`,
            changeRestorePassword: `auth/CHANGE_POPUP_RESTORE_PASSWORD`,
            changeSetNewPassword: `auth/CHANGE_POPUP_SET_NEW_PASSWORD`,
            changePersonalData: `auth/CHANGE_POPUP_PERSONAL_DATA`,
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
            changePopupConfirmPayment: `payment/CHANGE_POPUP_CONFIRM_PAYMENT`,
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
            changeShowNotLeavePopup: "setting/SHOW_NOT_LEAVE_POPUP",
            changeShowNeedConsultation: "setting/SHOW_NEED_CONSULTATION",
        }),
        hideNotLeavePopup() {
            this.changeShowNotLeavePopup(false);
            localStorage.setItem('not-leave', 1);
        }
    },
};
